// extracted by mini-css-extract-plugin
export var divider = "_fg-7";
export var itemsToggle = "_fg-8";
export var mergeModal = "_fg-1";
export var optionCard = "_fg-4";
export var radioGroup = "_fg-6";
export var radioOption = "_fg-0";
export var selected = "_fg-5";
export var shipmentOptions = "_fg-2";
export var tableOptions = "_fg-3";